// extracted by mini-css-extract-plugin
module.exports = {"legalText":"LegalText_legalText__H7av7"};